import { createFileRoute, redirect } from '@tanstack/react-router';
import { DTC_FILE_REQUEST_BASE_PATH } from '../../../../../../../../../features/dtc/files/v1/dtc-file-request-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/')({
  beforeLoad: () => {
    throw redirect({ to: DTC_FILE_REQUEST_BASE_PATH });
  },
  preload: false,
});
